var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMigrationToCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFD545;}\r\n\t.st2{fill:none;stroke:#333333;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st3{fill:#333333;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 28,
    y1: 34.6821,
    x2: 28,
    y2: 1.0127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3184,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.2,34.7h11c4.3,0,7.8-3.5,7.8-7.8c0-4.1-3.2-7.5-7.3-7.8c0-0.2,0-0.4,0-0.6C47.8,12.7,43.1,8,37.2,8 C36.1,8,35,8.2,34,8.5C32.3,4.1,28,1,23,1c-6.5,0-11.9,5.3-11.9,11.9c0,0.3,0,0.5,0,0.8C5.5,13.9,1,18.5,1,24.2 C1,30,5.7,34.7,11.5,34.7h8.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1,56H19.9c-1.9,0-3.4-1.5-3.4-3.4V27.7c0-1.9,1.5-3.4,3.4-3.4h16.3c1.9,0,3.4,1.5,3.4,3.4v24.9 C39.5,54.5,38,56,36.1,56z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.2,34.7h11c4.3,0,7.8-3.5,7.8-7.8c0-4.1-3.2-7.5-7.3-7.8c0-0.2,0-0.4,0-0.6C47.8,12.7,43.1,8,37.2,8 C36.1,8,35,8.2,34,8.5C32.3,4.1,28,1,23,1c-6.5,0-11.9,5.3-11.9,11.9c0,0.3,0,0.5,0,0.8C5.5,13.9,1,18.5,1,24.2 C1,30,5.7,34.7,11.5,34.7h8.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.2,34.7h11c4.3,0,7.8-3.5,7.8-7.8c0-4.1-3.2-7.5-7.3-7.8c0-0.2,0-0.4,0-0.6C47.8,12.7,43.1,8,37.2,8 C36.1,8,35,8.2,34,8.5C32.3,4.1,28,1,23,1c-6.5,0-11.9,5.3-11.9,11.9c0,0.3,0,0.5,0,0.8C5.5,13.9,1,18.5,1,24.2 C1,30,5.7,34.7,11.5,34.7h8.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28,47.7c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.5-1.3,1.2-1.3c0.7,0,1.2,0.5,1.2,1.2c0,0,0,0,0,0 C29.3,47.1,28.7,47.7,28,47.7C28,47.7,28,47.7,28,47.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28,51.5c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.5-1.3,1.2-1.3c0,0,0,0,0,0c0.7,0,1.2,0.5,1.2,1.2c0,0,0,0,0,0 C29.3,50.9,28.8,51.5,28,51.5C28,51.5,28,51.5,28,51.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.7,31.8L28,28.4 M28,28.4v13.3 M28,28.4l-3.7,3.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrationToCloud);
export default __webpack_public_path__ + "static/media/migration_to_cloud.e0d991561973af047463291655b5654f.svg";
export { ForwardRef as ReactComponent };